import React from 'react'
import {useDispatch} from 'react-redux'
import {styled} from '@material-ui/core/styles'
import MuiFormControlLabel from '@material-ui/core/FormControlLabel'
import MuiCheckbox from '@material-ui/core/Checkbox'
import {useCurrentSearchFilters} from 'searches/hooks'
import {updateCurrentSearchFilters} from 'searches/store/actions'
import {useCurrentUser} from 'users/hooks'
import {useCookies} from 'react-cookie'
import {THIRTY_DAYS} from 'constants/timeIntervals'
import {SYSTEM_TYPES} from 'lms/constants/systemTypes'

const Fieldset = styled('fieldset')(({theme}) => ({
  margin: 0,
  borderColor: 'rgba(0, 0, 0, 0.23)',
  borderStyle: 'solid',
  borderWidth: 1,
  borderRadius: theme.shape.borderRadius
}))

const Legend = styled('legend')(({theme}) => ({
  padding: 5,
  fontSize: 12,
  color: theme.palette.text.secondary
}))

const Row = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  padding: '0 7px'
})

const FormControlLabel = styled(MuiFormControlLabel)({})

const Checkbox = styled(MuiCheckbox)({})

const SystemType = ({labelText = 'Type of Learning System', ...props}) => {
  const filters = useCurrentSearchFilters()
  const dispatchRedux = useDispatch()
  const [cookies, setCookie] = useCookies(['guestSearchCount'])
  const user = useCurrentUser()
  const isGuestUser = !user

  const isChecked = value => (filters.systemType || []).includes(value)

  const setCheck = (value, checked) => {
    const set = new Set(filters.systemType || [])
    checked ? set.add(value) : set.delete(value)
    if (isGuestUser) {
      const guestSearchCount = cookies.guestSearchCount || 0
      setCookie(
        'guestSearchCount',
        Number(guestSearchCount) + 1,
        {path: '/'},
        THIRTY_DAYS
      )
    }
    dispatchRedux(updateCurrentSearchFilters({systemType: Array.from(set)}))
  }

  const createCheck = value => (
    <Checkbox
      checked={isChecked(value)}
      onChange={(e, checked) => setCheck(value, checked)}
    />
  )

  return (
    <Fieldset {...props}>
      <Legend>{labelText}</Legend>
      <Row>
        {SYSTEM_TYPES.map(({value, display}) => (
          <FormControlLabel
            key={value}
            label={display}
            control={createCheck(value)}
          />
        ))}
      </Row>
    </Fieldset>
  )
}

export default SystemType
